'use strict'

import React from 'react'
import Post from './PostComponent'
import $ from 'jquery'

let config = require('config');

require('styles/Single.less')

class Single extends React.Component {
  constructor(props)
  {
    super(props)
  }
  componentWillMount()
  {
  }
  componentDidMount()
  {
    this.updateSingle()
  }
  componentWillUnmount()
  {
    const { actions, data } = this.props;
    actions.removeSinglePost()
  }
  componentDidUpdate() {
    this.updateSingle()
  }
  updateSingle() {
    const { actions, data, params } = this.props;
    var slug = params.slug
    if (slug != data.currentSingleSlug) {
      data.selectCat = null
      actions.setCurrentSingleSlug(slug)
      actions.getSingleBySlug(slug)
      actions.setCurrentIndex(1)
      actions.getIndexPosts(1)
      actions.indexClose()
      $(window).scrollTop(0)
    }
  }
  render() {
    const { data } = this.props;
    if (data.singlePost == null || data.categories == null) {
      return (<div/>)
    }
    document.title = data.singlePost[0].title.rendered + " | " + config.default.SITE_NAME
    return (
      <div className='single'>
        <Post post={data.singlePost[0]} cat={data.categories} type='single' />
      </div>
    )
  }
}

Single.displayName = 'Single'
Single.propTypes = {}
Single.defaultProps = {}

export default Single



// WEBPACK FOOTER //
// ./src/components/SingleComponent.js